<template>
  <div class="process-simple-wrapper">
    <div class="process-simple-wrapper-content">
      <div class="process-simple-stage" v-for="(stage, stageIndex) in steps" :key="stageIndex">
        <ul>
          <li :class="`activity-line-${stage.status}`">
            <i :class="`node-icon-main activity-${stage.status}`"></i>
            <div class="time">{{ stage.name }}</div>
          </li>
          <li
            v-for="(childStage, childStageIndex) in stage.children"
            :key="childStageIndex"
            :class="`activity-line-${childStage.status}`"
          >
            <i :class="`node-icon activity-${childStage.status}`"></i>
            <div class="time">{{ childStage.name }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Steps, Step } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

export default {
  name: 'SkyPocStep',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    activityStep: {
      type: Object,
      default: () => {
        return { main: 0, children: 0 }
      }
    },
    steps: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    steps: {
      handler() {
        this.chanageStepData()
      },
      deep: true
    },
    activityStep: {
      handler() {
        this.chanageStepData()
      },
      deep: true
    }
  },
  computed: {},
  created() {
    this.chanageStepData()
  },
  data() {
    return {
      processData: []
    }
  },
  mounted() {},
  methods: {
    clickMenu(mainStep, childStep, type) {
      if ('main' === type) {
        // this.$emit('changeMenu', { main: mainStep, children: null, type: type })
      } else {
        this.$emit('changeMenu', { main: mainStep, children: childStep, type: type })
      }
    },
    chanageStepData() {
      this.processData = []
      for (let x = 0; x < this.steps.length; x++) {
        const element = this.steps[x]
        let stepData = {
          main: x,
          level: 1,
          enableMain: true,
          children: null,
          context: element.name
        }

        if (x < this.activityStep.main) {
          stepData.status = 'done'
        }
        if (x == this.activityStep.main) {
          stepData.status = 'inprogess'
        }
        if (x > this.activityStep.main) {
          stepData.status = 'todo'
        }

        this.processData.push(stepData)
        if (element.children && element.children.length > 0) {
          var childStep = element.children

          for (let j = 0; j < childStep.length; j++) {
            const chidlItem = childStep[j]
            let childStepData = {
              type: 1,
              level: 2,
              main: x,
              children: j,
              enableMain: false,
              context: chidlItem.name
            }
            if (j < this.activityStep.children) {
              childStepData.status = 'done'
            }
            if (j == this.activityStep.children) {
              childStepData.status = 'inprogess'
            }
            if (j > this.activityStep.children) {
              childStepData.status = 'todo'
            }
            this.processData.push(childStepData)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
.process-simple-wrapper {
  margin-top: 36px;
  .process-simple-wrapper-content ul li {
    list-style: none;
  }
  .activity-done {
    background-color: rgb(9, 236, 9);
  }
  .activity-line-done {
    border-left: 1px solid rgb(9, 236, 9) !important;
  }
  .activity-inprogess {
    background-color: rgb(255, 148, 62);
  }
  .activity-line-inprogess {
    border-left: 1px solid rgb(9, 236, 9) !important;
  }
  .activity-todo {
    background-color: #909399;
  }

  .process-simple-stage {
    max-width: 900px;
  }

  .process-simple-stage ul li:last-child {
    border: none !important;
  }

  .process-simple-wrapper-content {
    margin: 24px 12px;
    padding-left: 5px;
    position: relative;
  }

  .process-simple-wrapper-content li {
    position: relative;
    padding: 0 0 0 25px;
    line-height: 48px;
    border-left: 1px solid #d9d9d9;
    color: #999;
  }

  .process-simple-wrapper-content li .node-icon {
    position: absolute;
    left: -6px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
  }

  .process-simple-wrapper-content li .node-icon-main {
    position: absolute;
    left: -8px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
  }

  .process-simple-wrapper-content li .time {
    margin-right: 20px;
    margin-top: -45px;
    position: relative;
    top: 4px;
    display: inline-block;
    vertical-align: middle;
  }

  .process-simple-wrapper-content li .txt {
    max-width: 600px;
    position: relative;
    top: 4px;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
